<app-window class="login">
  <span title>{{ 'features.login.title' | translate }}</span>
  <div body>
    <div>
      <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="login-form__title">
          <h2>Login</h2>
        </div>

        @if (errorMessage()) {
          <div class="login-form__error" role="alert">
            {{ errorMessage()! | translate }}
          </div>
        }

        <div class="login-form__input">
          <label for="email">{{ 'features.login.email' | translate }}</label>
          <input name="email" type="email" id="email" formControlName="email" autocomplete="username" [class.error]="hasError('email')" />
          @if (hasError('email')) {
            <div class="login-form__field-error" role="alert">
              {{ getErrorMessage('email') | translate }}
            </div>
          }
        </div>
        <div class="login-form__input">
          <label for="password">{{ 'features.login.password' | translate }}</label>
          <input name="password" type="password" id="password" formControlName="password" autocomplete="current-password" />
          <a class="login-form__forgot" routerLink="/user/reset-password">{{ 'features.login.iForgor' | translate }}</a>
        </div>
        <div class="login-form__buttons">
          <button class="main-button" [disabled]="form.invalid || isLoading() || errorMessage()">
            {{ 'features.login.login' | translate }}
          </button>
          <span>{{ 'features.login.or' | translate }}</span>
          <a routerLink="/user/create-account">{{ 'features.login.createAccount' | translate }}</a>
        </div>
      </form>
    </div>
  </div>
</app-window>
